export default "__VITE_ASSET__B016zmNE__"